import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

interface PrivacyInfoDialogProps {
  isOpen: boolean
  onClose: () => unknown
  testId?: string
  closeButtonTestId?: string
}

/**
 * Privacy Info Dialog
 */
export function PrivacyInfoDialog({
  isOpen,
  onClose,
  testId,
  closeButtonTestId,
}: PrivacyInfoDialogProps) {
  return (
    <ModalDialog isOpen={isOpen} onClose={onClose} size="lg" testId={testId}>
      <ModalDialogHeader>
        <ModalDialogTitle>We take your privacy seriously</ModalDialogTitle>
        <ModalDialogDescription>
          <p>
            We wouldn't ask for your social security number or individual
            taxpayer identification number if they weren't required to file your
            tax return. This information is essential to file a return and claim
            possible credits.
          </p>
          <p>
            We are annually tested to confirm we meet SOC 2 Type II and ISO
            27001 compliance requirements. These compliance audits are performed
            by external auditors to review and examine our information security
            control measures and operations.
          </p>
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            variant="outline"
            label="Close"
            onPress={onClose}
            testId={closeButtonTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
